export default "__VITE_ASSET__8e576c0a__"